export default function Footer() {
  return (
    <footer className="relative z-10 border-t border-white/5 mt-8">
      <div className="max-w-[600px] mx-auto px-5 py-8 text-center space-y-2" data-testid="footer-bar">
        <p className="font-jetmono text-[10px] tracking-[0.2em] text-[#8a8a9e]">
          © 2026 VERITARGA · PAGAMENTI SICURI GESTITI DA STRIPE
        </p>
        <p className="font-jetmono text-[9px] tracking-[0.2em] text-[#8a8a9e]/60">
          REPORT UNICO DA 35,00 € · SBLOCCO COLLEGATO ALLA TARGA
        </p>
      </div>
    </footer>
  );
}
